import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

// Build the Day + Time dropdown options for Create My Event from the session
// catalog, so they always match the real agenda. All in the conference tz (ET).
export function buildEventOptions(sessions, tz) {
    const starts = []
    const days = new Map() // 'YYYY-MM-DD' -> label
    let min = null
    let max = null

    for (const s of sessions || []) {
        const start = s.start_date_and_time ? dayjs(s.start_date_and_time).tz(tz) : null
        const end = s.end_date_and_time ? dayjs(s.end_date_and_time).tz(tz) : null
        if (!start || !start.isValid()) continue
        const key = start.format('YYYY-MM-DD')
        if (!days.has(key)) days.set(key, start.format('ddd • MMM D'))
        const startMins = start.hour() * 60 + start.minute()
        const endD = end && end.isValid() ? end : start
        const endMins = endD.hour() * 60 + endD.minute()
        min = min === null ? startMins : Math.min(min, startMins)
        max = max === null ? endMins : Math.max(max, endMins)
        starts.push(start)
    }

    const dayOptions = [...days.entries()]
        .sort(([a], [b]) => (a < b ? -1 : 1))
        .map(([value, label]) => ({ value, label }))

    const times = []
    if (min !== null && max !== null) {
        for (let m = min - (min % 15); m <= max; m += 15) {
            const h = Math.floor(m / 60)
            const mm = m % 60
            const value = `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
            const label = dayjs().hour(h).minute(mm).format('h:mm a')
            times.push({ value, label })
        }
    }

    return { days: dayOptions, times }
}

// day='YYYY-MM-DD', hhmm='HH:mm', interpreted in tz -> ISO (UTC) string.
export function composeEventDateTime(day, hhmm, tz) {
    return dayjs.tz(`${day} ${hhmm}`, 'YYYY-MM-DD HH:mm', tz).utc().toISOString()
}
